import React from "react";
import { useHorizontalScroll } from "../../lib/hooks/useHorizontalScroll";
import RoadmapItem from "./RoadmapItem";

const Roadmap = () => {
  const roadmap_items = [
    {
      roadmapTitle: "Q2 2025",
      info: [
        "● DIAG Token Pre-Sale Launch",
        "● Bounty & Airdrop Programs Activated",
        "● Listing Agreement with HUMB Finalized",
        "● Community Building & Early Partnerships",
        "● Token Smart Contracts Deployed (audited)",
      ],
    },
    {
      roadmapTitle: "Q3 2025",
      info: [
        "● DIAG Token Paired with HUMB Native Token",
        "● Token Utility Integration Begins",
        "● Social Media Engagement Expansion",
        "● CEX/DEX Listing Preparation",
        "● Ambassador Program Launch",
      ],
    },

    {
      roadmapTitle: "Q4 2025",
      info: [
        "● DIAG Staking Program Fully Launched",
        "● Rewards for Patients and Clinicians Begin",
        "● Enhanced App Integration with DIAG Utility",
        "● Token Burn Mechanism Planning",
      ],
    },

    {
      roadmapTitle: "Q1 2026",
      info: [
        "● DIAG Token Integrated into Diagnostica Apps",
        "● Expanding Use Case for Healthcare Payments",
        "● Security Audits and Smart Contract Optimization",
      ],
    },
    {
      roadmapTitle: "Q2 2026",
      info: [
        "● DIAG Healthcare Rebates Go Live",
        "● New Partnerships with Wellness Providers",
        "● Utility Expansion into New Regions (Globally)",
      ],
    },
    {
      roadmapTitle: "Q3 2026",
      info: [
        "● DIAG Rewards Linked to Wearable Devices (Diagnostica Integrated)",
        "● Expanded Rebates for Healthcare Services",
        "● In-App AR Pain Mapping Beta Launch",
        "● Global Influencer & Thought Leader Onboarding",
      ],
    },
    {
      roadmapTitle: "Q4 2026",
      info: [
        "● Broader App Integration & Cross-Ecosystem Utility",
        "● More Healthcare Rebates Across Services & Regions",
        "● Preparation for Major Exchange Listings (CEX)",
        "● Roadmap Update & Next-Phase Announcement",
      ],
    },
  ];

  const scrollRef = useHorizontalScroll();

  return (
    <section id="roadmap" className="roadmap-area pt-130 pb-130 pb-0">
      <div className="container custom-container-two">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-8">
            <div className="section-title text-center mb-60">
              <h2 className="title">
                DIAG Token <span>Roadmap</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div
              className="bt-roadmap_x bt-roadmap-scrollbar"
              ref={scrollRef}
              style={{ overflow: "auto" }}
            >
              <div className="bt-roadmap-wrap">
                {roadmap_items.map((x, index) => (
                  <RoadmapItem key={index} item={x} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
